import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { of, switchMap } from 'rxjs';
import { ProductionWithheldManager } from '../../../../managers/production-withheld.manager';
import { FieldLayoutViewModel } from '../../../../models/field/field-layout-view-model.model';
import { ProductionJob } from '../../../../models/review/production-job.model';
import { FileRecord } from '../../../../models/ui/file.model';
import { FieldLayoutViewModelService } from '../../../../services/field-layout-view-model.service';
import { SelectFieldsDialogComponent } from '../../../dialogs/select-fields/select-fields.component';

@Component({
    selector: 'lex-production-withheld-log-dialog',
    templateUrl: './production-withheld-log-dialog.component.html',
    styleUrls: ['./production-withheld-log-dialog.component.scss'],
    standalone: false
})
export class ProductionWithheldLogDialogComponent {
	private productionJob: ProductionJob;
	private defaultPrivilegedFieldLayout: FieldLayoutViewModel = {
		fieldLayoutId: null,
		displayTitle: null,
		modifiedByUserId: null,
		modifiedDateTime: null,
		isPinned: false,
		isShared: false,
		fields: []
	};

	public fileList: FileRecord[];
	public shouldShowCreateWithheldLog: boolean;

	constructor(
		private withheldManager: ProductionWithheldManager,
		private fieldLayoutViewModelService: FieldLayoutViewModelService,
		private dialog: MatDialog,
		private dialogRef: MatDialogRef<ProductionWithheldLogDialogComponent, boolean>,
		@Inject(MAT_DIALOG_DATA) data: { files: FileRecord[], productionJob: ProductionJob }) {
		this.fileList = data.files;
		this.productionJob = data.productionJob;
		this.shouldShowCreateWithheldLog = !(this.fileList.some((x) => x.type === 'outgoing-production-withheld-log'));
		this.fieldLayoutViewModelService.getDefaultWithheldLogLayout().subscribe(data => this.defaultPrivilegedFieldLayout = data);
	}

	public downloadFile(file: FileRecord): void {
		this.withheldManager.downloadFile(file).subscribe((response) => {
			window.open(response, '_blank');
			this.dialogRef.close();
		});
	}

	public createWithheldLog(): void {
		const dialogRef = this.dialog.open(SelectFieldsDialogComponent,
			{
				data: {
					// Pass in copies so that the current selection can't be mutated (if the user changes the selection and closes without confirming, we don't want to update the selection)
					view: JSON.parse(JSON.stringify(this.defaultPrivilegedFieldLayout)),
					isSearch: false,
					isLog: true
				}
			});
		dialogRef.afterClosed().pipe(
			switchMap((data: FieldLayoutViewModel) => {
				if (!data) return of(null);
				return this.withheldManager.scheduleWithheldExportLog(this.productionJob.productionJobId, 'outgoing-production-withheld-log', data.fields);
			})).subscribe(() => {
				this.dialogRef.close(true);
			});
	}

	public delete(file: FileRecord): void {
		this.withheldManager.deleteFile(this.productionJob.productionJobId, file.id).subscribe(() => {
			const index = this.fileList.indexOf(file);
			if (index > -1)
				this.fileList.splice(index, 1);
			if (!(this.fileList.some((x) => x.type === 'outgoing-production-withheld-log')))
				this.shouldShowCreateWithheldLog = true;
		});
	}
}
